import EventDispatcher from 'eventdispatcher';
import moment from 'moment';
import { GoogleCalendar } from './providers/google-calendar';
import { Mixcloud } from './providers/mixcloud';
import { Airtime } from './providers/airtime';
import { Youtube } from './providers/youtube';

var _instance = null;

export class StudioManager extends EventDispatcher {
  static get instance () {
    if (!_instance) _instance = new StudioManager();
    return _instance;
  }

  constructor () {
    super();
    this.streamUrl = 'https://cdn-hlm-1.streamnerd.nl/live/kioskradio/playlist.m3u8';
    this.youtubeEpisodes = [];
  }

  init = () => {
    /* Wait until video lib is loaded */
    if (!window.videojs) { setTimeout(this.init, 250); return; }

    this.google = new GoogleCalendar();
    this.google.load().then(() => {
      this.emit('calendar-loaded');
      setInterval(this.checkWhosPlaying, 10 * 1000);
      this.checkWhosPlaying();
    });

    this.mixcloud = new Mixcloud();
    this.mixcloud.load().then(() => {
      this.emit('episodes-loaded');
      console.log('Got mixcloud data');
    })

    this.youtube = new Youtube();
    this.moreYoutube();

    setInterval(this.checkStream, 5 * 1000);
    this.checkStream();

    this.airtime = new Airtime();
    this.airtime.init();
    this.updateAirtime();

    setInterval(this.updateAirtime, 10 * 1000);
  }

  get tags () {
    const _tags = new Set();
    this.episodes.forEach(episode => _tags.add(...episode.tags));
    return Array.from(_tags).filter(tag => tag);
  }

  moreYoutube () {
    this.youtube.load().then(episodes => {
      this.youtubeEpisodes.push(...episodes);
      this.emit('youtube-loaded');
    })
  }

  checkStream = () => {
    window.fetch(this.streamUrl).then(response => {
      if (response.status === 200) this.emit('stream-online');
      else this.emit('stream-offline');
    }).catch(() => {
      this.emit('stream-offline');
    });
  }

  updateAirtime = () => {
    this.airtime.loadMeta().then(show => {
      this.emit('airtime-meta', { show });
    })
  }

  stopAirtime = () => {
    this.airtime.stop();
    this.emit('airtime-stop');
  }

  toggleAirtime = () => {
    var event = this.airtime.toggle();
    this.emit(event);
  }

  checkWhosPlaying = () => {
    this.google.filter();

    this.slotA = this.google.eventsUpcoming[0];
    this.slotB = this.google.eventsUpcoming[1];

    this.emit('slots-updated');
  }

  search = (term) => {
    this.lastTerm = term;
    this.emit('search-start', { term });
    this.mixcloud.search(term).then(() => {
      this.emit('search-end', { term });
    })
  }

  get agenda () {
    return this.google?.agenda || [];
  }

  get episodes () {
    return this.mixcloud ? this.mixcloud.episodes : [];
  }

  get searchResults () {
    return this.mixcloud ? this.mixcloud.searchResults : [];
  }

  get randomStaffPick () {
    if (!this._randomStaffPick) this._randomStaffPick = Math.round(Math.random() * 8);
    var staffPicks = this.episodes.filter(episode => episode.staffPick);
    return staffPicks[this._randomStaffPick];
  }

  playRamdomStaffPick = () => {
    var target = this.randomStaffPick.url.replace('https://www.mixcloud.com', '');
    StudioManager.instance.widget.play(target);
  }
}